"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _css = require("../css.js");

var _array = require("../array.js");

var _Layer = require("../layer/Layer.js");

var _dom = require("../dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/Attribution
 */


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */

/**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */
var Attribution =
/** @class */
function (_super) {
  __extends(Attribution, _super);
  /**
   * @param {Options} [opt_options] Attribution options.
   */


  function Attribution(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      render: options.render,
      target: options.target
    }) || this;
    /**
     * @private
     * @type {HTMLElement}
     */

    _this.ulElement_ = document.createElement('ul');
    /**
     * @private
     * @type {boolean}
     */

    _this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
    /**
     * @private
     * @type {boolean}
     */

    _this.userCollapsed_ = _this.collapsed_;
    /**
     * @private
     * @type {boolean}
     */

    _this.overrideCollapsible_ = options.collapsible !== undefined;
    /**
     * @private
     * @type {boolean}
     */

    _this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;

    if (!_this.collapsible_) {
      _this.collapsed_ = false;
    }

    var className = options.className !== undefined ? options.className : 'ol-attribution';
    var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
    var expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
    var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\u203A";
    var collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';

    if (typeof collapseLabel === 'string') {
      /**
       * @private
       * @type {HTMLElement}
       */
      _this.collapseLabel_ = document.createElement('span');
      _this.collapseLabel_.textContent = collapseLabel;
      _this.collapseLabel_.className = collapseClassName;
    } else {
      _this.collapseLabel_ = collapseLabel;
    }

    var label = options.label !== undefined ? options.label : 'i';

    if (typeof label === 'string') {
      /**
       * @private
       * @type {HTMLElement}
       */
      _this.label_ = document.createElement('span');
      _this.label_.textContent = label;
      _this.label_.className = expandClassName;
    } else {
      _this.label_ = label;
    }

    var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
    /**
     * @private
     * @type {HTMLElement}
     */

    _this.toggleButton_ = document.createElement('button');

    _this.toggleButton_.setAttribute('type', 'button');

    _this.toggleButton_.setAttribute('aria-expanded', String(!_this.collapsed_));

    _this.toggleButton_.title = tipLabel;

    _this.toggleButton_.appendChild(activeLabel);

    _this.toggleButton_.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this), false);

    var cssClasses = className + ' ' + _css.CLASS_UNSELECTABLE + ' ' + _css.CLASS_CONTROL + (_this.collapsed_ && _this.collapsible_ ? ' ' + _css.CLASS_COLLAPSED : '') + (_this.collapsible_ ? '' : ' ol-uncollapsible');
    var element = _this.element;
    element.className = cssClasses;
    element.appendChild(_this.toggleButton_);
    element.appendChild(_this.ulElement_);
    /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */

    _this.renderedAttributions_ = [];
    /**
     * @private
     * @type {boolean}
     */

    _this.renderedVisible_ = true;
    return _this;
  }
  /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */


  Attribution.prototype.collectSourceAttributions_ = function (frameState) {
    /**
     * Used to determine if an attribution already exists.
     * @type {!Object<string, boolean>}
     */
    var lookup = {};
    /**
     * A list of visible attributions.
     * @type {Array<string>}
     */

    var visibleAttributions = [];
    var collapsible = true;
    var layerStatesArray = frameState.layerStatesArray;

    for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
      var layerState = layerStatesArray[i];

      if (!(0, _Layer.inView)(layerState, frameState.viewState)) {
        continue;
      }

      var source =
      /** @type {import("../layer/Layer.js").default} */
      layerState.layer.getSource();

      if (!source) {
        continue;
      }

      var attributionGetter = source.getAttributions();

      if (!attributionGetter) {
        continue;
      }

      var attributions = attributionGetter(frameState);

      if (!attributions) {
        continue;
      }

      collapsible = collapsible && source.getAttributionsCollapsible() !== false;

      if (Array.isArray(attributions)) {
        for (var j = 0, jj = attributions.length; j < jj; ++j) {
          if (!(attributions[j] in lookup)) {
            visibleAttributions.push(attributions[j]);
            lookup[attributions[j]] = true;
          }
        }
      } else {
        if (!(attributions in lookup)) {
          visibleAttributions.push(attributions);
          lookup[attributions] = true;
        }
      }
    }

    if (!this.overrideCollapsible_) {
      this.setCollapsible(collapsible);
    }

    return visibleAttributions;
  };
  /**
   * @private
   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
   */


  Attribution.prototype.updateElement_ = function (frameState) {
    if (!frameState) {
      if (this.renderedVisible_) {
        this.element.style.display = 'none';
        this.renderedVisible_ = false;
      }

      return;
    }

    var attributions = this.collectSourceAttributions_(frameState);
    var visible = attributions.length > 0;

    if (this.renderedVisible_ != visible) {
      this.element.style.display = visible ? '' : 'none';
      this.renderedVisible_ = visible;
    }

    if ((0, _array.equals)(attributions, this.renderedAttributions_)) {
      return;
    }

    (0, _dom.removeChildren)(this.ulElement_); // append the attributions

    for (var i = 0, ii = attributions.length; i < ii; ++i) {
      var element = document.createElement('li');
      element.innerHTML = attributions[i];
      this.ulElement_.appendChild(element);
    }

    this.renderedAttributions_ = attributions;
  };
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */


  Attribution.prototype.handleClick_ = function (event) {
    event.preventDefault();
    this.handleToggle_();
    this.userCollapsed_ = this.collapsed_;
  };
  /**
   * @private
   */


  Attribution.prototype.handleToggle_ = function () {
    this.element.classList.toggle(_css.CLASS_COLLAPSED);

    if (this.collapsed_) {
      (0, _dom.replaceNode)(this.collapseLabel_, this.label_);
    } else {
      (0, _dom.replaceNode)(this.label_, this.collapseLabel_);
    }

    this.collapsed_ = !this.collapsed_;
    this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
  };
  /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */


  Attribution.prototype.getCollapsible = function () {
    return this.collapsible_;
  };
  /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */


  Attribution.prototype.setCollapsible = function (collapsible) {
    if (this.collapsible_ === collapsible) {
      return;
    }

    this.collapsible_ = collapsible;
    this.element.classList.toggle('ol-uncollapsible');

    if (this.userCollapsed_) {
      this.handleToggle_();
    }
  };
  /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */


  Attribution.prototype.setCollapsed = function (collapsed) {
    this.userCollapsed_ = collapsed;

    if (!this.collapsible_ || this.collapsed_ === collapsed) {
      return;
    }

    this.handleToggle_();
  };
  /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */


  Attribution.prototype.getCollapsed = function () {
    return this.collapsed_;
  };
  /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */


  Attribution.prototype.render = function (mapEvent) {
    this.updateElement_(mapEvent.frameState);
  };

  return Attribution;
}(_Control["default"]);

var _default = Attribution;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBUkE7Ozs7O0FBVUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTJCQTs7Ozs7Ozs7O0FBU0E7QUFBQTtBQUFBO0VBQTBCQTtFQUN4Qjs7Ozs7RUFHQSxxQkFBWUMsV0FBWixFQUF1QjtJQUF2Qjs7SUFDRSxJQUFNQyxPQUFPLEdBQUdELFdBQVcsR0FBR0EsV0FBSCxHQUFpQixFQUE1QztZQUVBRSxrQkFBTTtNQUNKQyxPQUFPLEVBQUVDLFFBQVEsQ0FBQ0MsYUFBVCxDQUF1QixLQUF2QixDQURMO01BRUpDLE1BQU0sRUFBRUwsT0FBTyxDQUFDSyxNQUZaO01BR0pDLE1BQU0sRUFBRU4sT0FBTyxDQUFDTTtJQUhaLENBQU4sS0FJRTtJQUVGOzs7OztJQUlBQyxLQUFJLENBQUNDLFVBQUwsR0FBa0JMLFFBQVEsQ0FBQ0MsYUFBVCxDQUF1QixJQUF2QixDQUFsQjtJQUVBOzs7OztJQUlBRyxLQUFJLENBQUNFLFVBQUwsR0FDRVQsT0FBTyxDQUFDVSxTQUFSLEtBQXNCQyxTQUF0QixHQUFrQ1gsT0FBTyxDQUFDVSxTQUExQyxHQUFzRCxJQUR4RDtJQUdBOzs7OztJQUlBSCxLQUFJLENBQUNLLGNBQUwsR0FBc0JMLEtBQUksQ0FBQ0UsVUFBM0I7SUFFQTs7Ozs7SUFJQUYsS0FBSSxDQUFDTSxvQkFBTCxHQUE0QmIsT0FBTyxDQUFDYyxXQUFSLEtBQXdCSCxTQUFwRDtJQUVBOzs7OztJQUlBSixLQUFJLENBQUNRLFlBQUwsR0FDRWYsT0FBTyxDQUFDYyxXQUFSLEtBQXdCSCxTQUF4QixHQUFvQ1gsT0FBTyxDQUFDYyxXQUE1QyxHQUEwRCxJQUQ1RDs7SUFHQSxJQUFJLENBQUNQLEtBQUksQ0FBQ1EsWUFBVixFQUF3QjtNQUN0QlIsS0FBSSxDQUFDRSxVQUFMLEdBQWtCLEtBQWxCO0lBQ0Q7O0lBRUQsSUFBTU8sU0FBUyxHQUNiaEIsT0FBTyxDQUFDZ0IsU0FBUixLQUFzQkwsU0FBdEIsR0FBa0NYLE9BQU8sQ0FBQ2dCLFNBQTFDLEdBQXNELGdCQUR4RDtJQUdBLElBQU1DLFFBQVEsR0FDWmpCLE9BQU8sQ0FBQ2lCLFFBQVIsS0FBcUJOLFNBQXJCLEdBQWlDWCxPQUFPLENBQUNpQixRQUF6QyxHQUFvRCxjQUR0RDtJQUdBLElBQU1DLGVBQWUsR0FDbkJsQixPQUFPLENBQUNrQixlQUFSLEtBQTRCUCxTQUE1QixHQUNJWCxPQUFPLENBQUNrQixlQURaLEdBRUlGLFNBQVMsR0FBRyxTQUhsQjtJQUtBLElBQU1HLGFBQWEsR0FDakJuQixPQUFPLENBQUNtQixhQUFSLEtBQTBCUixTQUExQixHQUFzQ1gsT0FBTyxDQUFDbUIsYUFBOUMsR0FBOEQsUUFEaEU7SUFHQSxJQUFNQyxpQkFBaUIsR0FDckJwQixPQUFPLENBQUNvQixpQkFBUixLQUE4QlQsU0FBOUIsR0FDSVgsT0FBTyxDQUFDb0IsaUJBRFosR0FFSUosU0FBUyxHQUFHLFdBSGxCOztJQUtBLElBQUksT0FBT0csYUFBUCxLQUF5QixRQUE3QixFQUF1QztNQUNyQzs7OztNQUlBWixLQUFJLENBQUNjLGNBQUwsR0FBc0JsQixRQUFRLENBQUNDLGFBQVQsQ0FBdUIsTUFBdkIsQ0FBdEI7TUFDQUcsS0FBSSxDQUFDYyxjQUFMLENBQW9CQyxXQUFwQixHQUFrQ0gsYUFBbEM7TUFDQVosS0FBSSxDQUFDYyxjQUFMLENBQW9CTCxTQUFwQixHQUFnQ0ksaUJBQWhDO0lBQ0QsQ0FSRCxNQVFPO01BQ0xiLEtBQUksQ0FBQ2MsY0FBTCxHQUFzQkYsYUFBdEI7SUFDRDs7SUFFRCxJQUFNSSxLQUFLLEdBQUd2QixPQUFPLENBQUN1QixLQUFSLEtBQWtCWixTQUFsQixHQUE4QlgsT0FBTyxDQUFDdUIsS0FBdEMsR0FBOEMsR0FBNUQ7O0lBRUEsSUFBSSxPQUFPQSxLQUFQLEtBQWlCLFFBQXJCLEVBQStCO01BQzdCOzs7O01BSUFoQixLQUFJLENBQUNpQixNQUFMLEdBQWNyQixRQUFRLENBQUNDLGFBQVQsQ0FBdUIsTUFBdkIsQ0FBZDtNQUNBRyxLQUFJLENBQUNpQixNQUFMLENBQVlGLFdBQVosR0FBMEJDLEtBQTFCO01BQ0FoQixLQUFJLENBQUNpQixNQUFMLENBQVlSLFNBQVosR0FBd0JFLGVBQXhCO0lBQ0QsQ0FSRCxNQVFPO01BQ0xYLEtBQUksQ0FBQ2lCLE1BQUwsR0FBY0QsS0FBZDtJQUNEOztJQUVELElBQU1FLFdBQVcsR0FDZmxCLEtBQUksQ0FBQ1EsWUFBTCxJQUFxQixDQUFDUixLQUFJLENBQUNFLFVBQTNCLEdBQXdDRixLQUFJLENBQUNjLGNBQTdDLEdBQThEZCxLQUFJLENBQUNpQixNQURyRTtJQUdBOzs7OztJQUlBakIsS0FBSSxDQUFDbUIsYUFBTCxHQUFxQnZCLFFBQVEsQ0FBQ0MsYUFBVCxDQUF1QixRQUF2QixDQUFyQjs7SUFDQUcsS0FBSSxDQUFDbUIsYUFBTCxDQUFtQkMsWUFBbkIsQ0FBZ0MsTUFBaEMsRUFBd0MsUUFBeEM7O0lBQ0FwQixLQUFJLENBQUNtQixhQUFMLENBQW1CQyxZQUFuQixDQUFnQyxlQUFoQyxFQUFpREMsTUFBTSxDQUFDLENBQUNyQixLQUFJLENBQUNFLFVBQVAsQ0FBdkQ7O0lBQ0FGLEtBQUksQ0FBQ21CLGFBQUwsQ0FBbUJHLEtBQW5CLEdBQTJCWixRQUEzQjs7SUFDQVYsS0FBSSxDQUFDbUIsYUFBTCxDQUFtQkksV0FBbkIsQ0FBK0JMLFdBQS9COztJQUVBbEIsS0FBSSxDQUFDbUIsYUFBTCxDQUFtQkssZ0JBQW5CLENBQ0VDLHNCQUFVQyxLQURaLEVBRUUxQixLQUFJLENBQUMyQixZQUFMLENBQWtCQyxJQUFsQixDQUF1QjVCLEtBQXZCLENBRkYsRUFHRSxLQUhGOztJQU1BLElBQU02QixVQUFVLEdBQ2RwQixTQUFTLEdBQ1QsR0FEQSxHQUVBcUIsdUJBRkEsR0FHQSxHQUhBLEdBSUFDLGtCQUpBLElBS0MvQixLQUFJLENBQUNFLFVBQUwsSUFBbUJGLEtBQUksQ0FBQ1EsWUFBeEIsR0FBdUMsTUFBTXdCLG9CQUE3QyxHQUErRCxFQUxoRSxLQU1DaEMsS0FBSSxDQUFDUSxZQUFMLEdBQW9CLEVBQXBCLEdBQXlCLG1CQU4xQixDQURGO0lBUUEsSUFBTWIsT0FBTyxHQUFHSyxLQUFJLENBQUNMLE9BQXJCO0lBQ0FBLE9BQU8sQ0FBQ2MsU0FBUixHQUFvQm9CLFVBQXBCO0lBQ0FsQyxPQUFPLENBQUM0QixXQUFSLENBQW9CdkIsS0FBSSxDQUFDbUIsYUFBekI7SUFDQXhCLE9BQU8sQ0FBQzRCLFdBQVIsQ0FBb0J2QixLQUFJLENBQUNDLFVBQXpCO0lBRUE7Ozs7OztJQUtBRCxLQUFJLENBQUNpQyxxQkFBTCxHQUE2QixFQUE3QjtJQUVBOzs7OztJQUlBakMsS0FBSSxDQUFDa0MsZ0JBQUwsR0FBd0IsSUFBeEI7O0VBQ0Q7RUFFRDs7Ozs7Ozs7RUFNQUMsNkRBQTJCQyxVQUEzQixFQUFxQztJQUNuQzs7OztJQUlBLElBQU1DLE1BQU0sR0FBRyxFQUFmO0lBRUE7Ozs7O0lBSUEsSUFBTUMsbUJBQW1CLEdBQUcsRUFBNUI7SUFFQSxJQUFJL0IsV0FBVyxHQUFHLElBQWxCO0lBQ0EsSUFBTWdDLGdCQUFnQixHQUFHSCxVQUFVLENBQUNHLGdCQUFwQzs7SUFDQSxLQUFLLElBQUlDLENBQUMsR0FBRyxDQUFSLEVBQVdDLEVBQUUsR0FBR0YsZ0JBQWdCLENBQUNHLE1BQXRDLEVBQThDRixDQUFDLEdBQUdDLEVBQWxELEVBQXNELEVBQUVELENBQXhELEVBQTJEO01BQ3pELElBQU1HLFVBQVUsR0FBR0osZ0JBQWdCLENBQUNDLENBQUQsQ0FBbkM7O01BQ0EsSUFBSSxDQUFDLG1CQUFPRyxVQUFQLEVBQW1CUCxVQUFVLENBQUNRLFNBQTlCLENBQUwsRUFBK0M7UUFDN0M7TUFDRDs7TUFFRCxJQUFNQyxNQUFNO01BQUc7TUFDYkYsVUFBVSxDQUFDRyxLQURxRCxDQUVoRUMsU0FGZ0UsRUFBbEU7O01BR0EsSUFBSSxDQUFDRixNQUFMLEVBQWE7UUFDWDtNQUNEOztNQUVELElBQU1HLGlCQUFpQixHQUFHSCxNQUFNLENBQUNJLGVBQVAsRUFBMUI7O01BQ0EsSUFBSSxDQUFDRCxpQkFBTCxFQUF3QjtRQUN0QjtNQUNEOztNQUVELElBQU1FLFlBQVksR0FBR0YsaUJBQWlCLENBQUNaLFVBQUQsQ0FBdEM7O01BQ0EsSUFBSSxDQUFDYyxZQUFMLEVBQW1CO1FBQ2pCO01BQ0Q7O01BRUQzQyxXQUFXLEdBQ1RBLFdBQVcsSUFBSXNDLE1BQU0sQ0FBQ00sMEJBQVAsT0FBd0MsS0FEekQ7O01BR0EsSUFBSUMsS0FBSyxDQUFDQyxPQUFOLENBQWNILFlBQWQsQ0FBSixFQUFpQztRQUMvQixLQUFLLElBQUlJLENBQUMsR0FBRyxDQUFSLEVBQVdDLEVBQUUsR0FBR0wsWUFBWSxDQUFDUixNQUFsQyxFQUEwQ1ksQ0FBQyxHQUFHQyxFQUE5QyxFQUFrRCxFQUFFRCxDQUFwRCxFQUF1RDtVQUNyRCxJQUFJLEVBQUVKLFlBQVksQ0FBQ0ksQ0FBRCxDQUFaLElBQW1CakIsTUFBckIsQ0FBSixFQUFrQztZQUNoQ0MsbUJBQW1CLENBQUNrQixJQUFwQixDQUF5Qk4sWUFBWSxDQUFDSSxDQUFELENBQXJDO1lBQ0FqQixNQUFNLENBQUNhLFlBQVksQ0FBQ0ksQ0FBRCxDQUFiLENBQU4sR0FBMEIsSUFBMUI7VUFDRDtRQUNGO01BQ0YsQ0FQRCxNQU9PO1FBQ0wsSUFBSSxFQUFFSixZQUFZLElBQUliLE1BQWxCLENBQUosRUFBK0I7VUFDN0JDLG1CQUFtQixDQUFDa0IsSUFBcEIsQ0FBeUJOLFlBQXpCO1VBQ0FiLE1BQU0sQ0FBQ2EsWUFBRCxDQUFOLEdBQXVCLElBQXZCO1FBQ0Q7TUFDRjtJQUNGOztJQUNELElBQUksQ0FBQyxLQUFLNUMsb0JBQVYsRUFBZ0M7TUFDOUIsS0FBS21ELGNBQUwsQ0FBb0JsRCxXQUFwQjtJQUNEOztJQUNELE9BQU8rQixtQkFBUDtFQUNELENBM0REO0VBNkRBOzs7Ozs7RUFJQUgsaURBQWVDLFVBQWYsRUFBeUI7SUFDdkIsSUFBSSxDQUFDQSxVQUFMLEVBQWlCO01BQ2YsSUFBSSxLQUFLRixnQkFBVCxFQUEyQjtRQUN6QixLQUFLdkMsT0FBTCxDQUFhK0QsS0FBYixDQUFtQkMsT0FBbkIsR0FBNkIsTUFBN0I7UUFDQSxLQUFLekIsZ0JBQUwsR0FBd0IsS0FBeEI7TUFDRDs7TUFDRDtJQUNEOztJQUVELElBQU1nQixZQUFZLEdBQUcsS0FBS1UsMEJBQUwsQ0FBZ0N4QixVQUFoQyxDQUFyQjtJQUVBLElBQU15QixPQUFPLEdBQUdYLFlBQVksQ0FBQ1IsTUFBYixHQUFzQixDQUF0Qzs7SUFDQSxJQUFJLEtBQUtSLGdCQUFMLElBQXlCMkIsT0FBN0IsRUFBc0M7TUFDcEMsS0FBS2xFLE9BQUwsQ0FBYStELEtBQWIsQ0FBbUJDLE9BQW5CLEdBQTZCRSxPQUFPLEdBQUcsRUFBSCxHQUFRLE1BQTVDO01BQ0EsS0FBSzNCLGdCQUFMLEdBQXdCMkIsT0FBeEI7SUFDRDs7SUFFRCxJQUFJLG1CQUFPWCxZQUFQLEVBQXFCLEtBQUtqQixxQkFBMUIsQ0FBSixFQUFzRDtNQUNwRDtJQUNEOztJQUVELHlCQUFlLEtBQUtoQyxVQUFwQixFQXJCdUIsQ0F1QnZCOztJQUNBLEtBQUssSUFBSXVDLENBQUMsR0FBRyxDQUFSLEVBQVdDLEVBQUUsR0FBR1MsWUFBWSxDQUFDUixNQUFsQyxFQUEwQ0YsQ0FBQyxHQUFHQyxFQUE5QyxFQUFrRCxFQUFFRCxDQUFwRCxFQUF1RDtNQUNyRCxJQUFNN0MsT0FBTyxHQUFHQyxRQUFRLENBQUNDLGFBQVQsQ0FBdUIsSUFBdkIsQ0FBaEI7TUFDQUYsT0FBTyxDQUFDbUUsU0FBUixHQUFvQlosWUFBWSxDQUFDVixDQUFELENBQWhDO01BQ0EsS0FBS3ZDLFVBQUwsQ0FBZ0JzQixXQUFoQixDQUE0QjVCLE9BQTVCO0lBQ0Q7O0lBRUQsS0FBS3NDLHFCQUFMLEdBQTZCaUIsWUFBN0I7RUFDRCxDQS9CRDtFQWlDQTs7Ozs7O0VBSUFmLCtDQUFhNEIsS0FBYixFQUFrQjtJQUNoQkEsS0FBSyxDQUFDQyxjQUFOO0lBQ0EsS0FBS0MsYUFBTDtJQUNBLEtBQUs1RCxjQUFMLEdBQXNCLEtBQUtILFVBQTNCO0VBQ0QsQ0FKRDtFQU1BOzs7OztFQUdBaUM7SUFDRSxLQUFLeEMsT0FBTCxDQUFhdUUsU0FBYixDQUF1QkMsTUFBdkIsQ0FBOEJuQyxvQkFBOUI7O0lBQ0EsSUFBSSxLQUFLOUIsVUFBVCxFQUFxQjtNQUNuQixzQkFBWSxLQUFLWSxjQUFqQixFQUFpQyxLQUFLRyxNQUF0QztJQUNELENBRkQsTUFFTztNQUNMLHNCQUFZLEtBQUtBLE1BQWpCLEVBQXlCLEtBQUtILGNBQTlCO0lBQ0Q7O0lBQ0QsS0FBS1osVUFBTCxHQUFrQixDQUFDLEtBQUtBLFVBQXhCO0lBQ0EsS0FBS2lCLGFBQUwsQ0FBbUJDLFlBQW5CLENBQWdDLGVBQWhDLEVBQWlEQyxNQUFNLENBQUMsQ0FBQyxLQUFLbkIsVUFBUCxDQUF2RDtFQUNELENBVEQ7RUFXQTs7Ozs7OztFQUtBaUM7SUFDRSxPQUFPLEtBQUszQixZQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7O0VBS0EyQixpREFBZTVCLFdBQWYsRUFBMEI7SUFDeEIsSUFBSSxLQUFLQyxZQUFMLEtBQXNCRCxXQUExQixFQUF1QztNQUNyQztJQUNEOztJQUNELEtBQUtDLFlBQUwsR0FBb0JELFdBQXBCO0lBQ0EsS0FBS1osT0FBTCxDQUFhdUUsU0FBYixDQUF1QkMsTUFBdkIsQ0FBOEIsa0JBQTlCOztJQUNBLElBQUksS0FBSzlELGNBQVQsRUFBeUI7TUFDdkIsS0FBSzRELGFBQUw7SUFDRDtFQUNGLENBVEQ7RUFXQTs7Ozs7Ozs7O0VBT0E5QiwrQ0FBYWhDLFNBQWIsRUFBc0I7SUFDcEIsS0FBS0UsY0FBTCxHQUFzQkYsU0FBdEI7O0lBQ0EsSUFBSSxDQUFDLEtBQUtLLFlBQU4sSUFBc0IsS0FBS04sVUFBTCxLQUFvQkMsU0FBOUMsRUFBeUQ7TUFDdkQ7SUFDRDs7SUFDRCxLQUFLOEQsYUFBTDtFQUNELENBTkQ7RUFRQTs7Ozs7Ozs7RUFNQTlCO0lBQ0UsT0FBTyxLQUFLakMsVUFBWjtFQUNELENBRkQ7RUFJQTs7Ozs7OztFQUtBaUMseUNBQU9pQyxRQUFQLEVBQWU7SUFDYixLQUFLQyxjQUFMLENBQW9CRCxRQUFRLENBQUNoQyxVQUE3QjtFQUNELENBRkQ7O0VBR0Y7QUFBQyxDQXRVRCxDQUEwQmtDLG1CQUExQjs7ZUF3VWVuQyxXIiwibmFtZXMiOlsiX19leHRlbmRzIiwib3B0X29wdGlvbnMiLCJvcHRpb25zIiwiX3N1cGVyIiwiZWxlbWVudCIsImRvY3VtZW50IiwiY3JlYXRlRWxlbWVudCIsInJlbmRlciIsInRhcmdldCIsIl90aGlzIiwidWxFbGVtZW50XyIsImNvbGxhcHNlZF8iLCJjb2xsYXBzZWQiLCJ1bmRlZmluZWQiLCJ1c2VyQ29sbGFwc2VkXyIsIm92ZXJyaWRlQ29sbGFwc2libGVfIiwiY29sbGFwc2libGUiLCJjb2xsYXBzaWJsZV8iLCJjbGFzc05hbWUiLCJ0aXBMYWJlbCIsImV4cGFuZENsYXNzTmFtZSIsImNvbGxhcHNlTGFiZWwiLCJjb2xsYXBzZUNsYXNzTmFtZSIsImNvbGxhcHNlTGFiZWxfIiwidGV4dENvbnRlbnQiLCJsYWJlbCIsImxhYmVsXyIsImFjdGl2ZUxhYmVsIiwidG9nZ2xlQnV0dG9uXyIsInNldEF0dHJpYnV0ZSIsIlN0cmluZyIsInRpdGxlIiwiYXBwZW5kQ2hpbGQiLCJhZGRFdmVudExpc3RlbmVyIiwiRXZlbnRUeXBlIiwiQ0xJQ0siLCJoYW5kbGVDbGlja18iLCJiaW5kIiwiY3NzQ2xhc3NlcyIsIkNMQVNTX1VOU0VMRUNUQUJMRSIsIkNMQVNTX0NPTlRST0wiLCJDTEFTU19DT0xMQVBTRUQiLCJyZW5kZXJlZEF0dHJpYnV0aW9uc18iLCJyZW5kZXJlZFZpc2libGVfIiwiQXR0cmlidXRpb24iLCJmcmFtZVN0YXRlIiwibG9va3VwIiwidmlzaWJsZUF0dHJpYnV0aW9ucyIsImxheWVyU3RhdGVzQXJyYXkiLCJpIiwiaWkiLCJsZW5ndGgiLCJsYXllclN0YXRlIiwidmlld1N0YXRlIiwic291cmNlIiwibGF5ZXIiLCJnZXRTb3VyY2UiLCJhdHRyaWJ1dGlvbkdldHRlciIsImdldEF0dHJpYnV0aW9ucyIsImF0dHJpYnV0aW9ucyIsImdldEF0dHJpYnV0aW9uc0NvbGxhcHNpYmxlIiwiQXJyYXkiLCJpc0FycmF5IiwiaiIsImpqIiwicHVzaCIsInNldENvbGxhcHNpYmxlIiwic3R5bGUiLCJkaXNwbGF5IiwiY29sbGVjdFNvdXJjZUF0dHJpYnV0aW9uc18iLCJ2aXNpYmxlIiwiaW5uZXJIVE1MIiwiZXZlbnQiLCJwcmV2ZW50RGVmYXVsdCIsImhhbmRsZVRvZ2dsZV8iLCJjbGFzc0xpc3QiLCJ0b2dnbGUiLCJtYXBFdmVudCIsInVwZGF0ZUVsZW1lbnRfIiwiQ29udHJvbCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29udHJvbC9BdHRyaWJ1dGlvbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==